import {WithNamespaces} from 'react-i18next'
import {AccountType} from './types'
import messages from '../../../../../assets/messages'

const hasMessage = (messageKey: string): boolean => !!messages[messageKey]

const tByKey = (t: WithNamespaces['t'], messageKey: string): string => {
  const entry = messages[messageKey]
  if (!entry) console.error(`Missing translation for key: ${messageKey}`)
  return t(entry?.i18nKey, entry?.defaults)
}

const isDemoType = (accountType: AccountType): boolean => accountType.isDemo && hasMessage(`${accountType.category}${accountType.accountSubtype}DemoDesc`)

export const caption = (accountType: AccountType, t: WithNamespaces['t']) => {
  const {accountSubtype, baseProduct, category, subCategory} = accountType

  if (isDemoType(accountType)) return tByKey(t, `${category}${accountSubtype}DemoDesc`)

  if (hasMessage(`${category}${accountSubtype}Desc`)) return tByKey(t, `${category}${accountSubtype}Desc`)

  if (hasMessage(`${baseProduct}Desc`)) return tByKey(t, `${baseProduct}Desc`)

  return tByKey(t, `${category}${subCategory}Desc`)
}
